module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/soc_3-260a37df03f73ca628df8177fb9ac50e.svg";